/** @format */

import React, { useEffect, useMemo, useState } from "react";
import { Aviation, Expeditor, File, MapsData, Order, User } from "../../../services";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Loading from "../../../components/shared/Loading/Loading";
import { onDebounce, requestErrorDisplay } from "../../../utils";
import OrdersCreateAviationView from "../../../components/orders/views/OrdersCreateAviationView";
import { t } from "i18next";
import { useLanguage } from "../../../context/LanguageContext";
import { getCitiesRefreshTargets } from "../utils/cityRefresh";

import { buildAviationOrderPayload } from "../utils/aviationOrderPayload";
import useAviationAssignment from "../utils/useAviationAssignment";

const OrdersAviationCreatePage = () => {
  const location = useLocation();
  const params = useParams();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState(
    params?.id ? params?.id : searchParams.get("id") ? searchParams.get("id") : null,
  );
  const [recipientUpdate, setRecipientUpdate] = useState(0);
  const [isLoadingGet, setLoadingGet] = useState(
    location.pathname !== `/orders/draft/${orderId}/edit`,
  );
  const [isBackBtn, setBackBtn] = useState(0);

  // Default data
  const [orderDraft, setOrderDraft] = useState(null);
  const [countries, setCountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState([]);
  const [partners, setPartners] = useState([]);

  const [errors, setErrors] = useState({});
  // FORM
  // Selected data
  const [countryFrom, setCountryFrom] = useState();
  const [countryTo, setCountryTo] = useState();
  const [citiesFrom, setCitiesFrom] = useState([]);
  const [citiesTo, setCitiesTo] = useState([]);
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [airportFrom, setAirportFrom] = useState();
  const [airportTo, setAirportTo] = useState();
  const [airportsFrom, setAirportsFrom] = useState([]);
  const [airportsTo, setAirportsTo] = useState([]);
  const [pickUpDate, setPickUpDate] = useState();
  const [pickUpStartTime, setPickUpStartTime] = useState();
  const [pickUpEndTime, setPickUpEndTime] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [deliveryStartTime, setDeliveryStartTime] = useState();
  const [deliveryEndTime, setDeliveryEndTime] = useState();
  const [addressTo, setAddressTo] = useState();
  const [addressFrom, setAddressFrom] = useState();
  const [coordinatesFrom, setCoordinatesFrom] = useState("");
  const [coordinatesTo, setCoordinatesTo] = useState("");
  const [addressIdFrom, setAddressIdFrom] = useState("");
  const [addressIdTo, setAddressIdTo] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [recipientPhone, setRecipientPhone] = useState();
  const [senderName, setSenderName] = useState("");
  const [senderPhone, setSenderPhone] = useState();
  const [category, setCategory] = useState();
  const [categoryName, setCategoryName] = useState("");
  const [type, setType] = useState();
  const [weight, setWeight] = useState("");
  const [volume, setVolume] = useState("");
  const [details, setDetails] = useState();
  const [copyCount, setCopyCount] = useState(1);
  const [price, setPrice] = useState(0);
  const [distance, setDistance] = useState();
  const [temperature, setTemperature] = useState();
  const [loadingType, setLoadingType] = useState();
  const [createLoading, setLoadingCreate] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [declaredPrice, setDeclaredPrice] = useState(0);
  const [insurancePrice, setInsurancePrice] = useState();
  const [minPickDate, setMinPickDate] = useState(new Date(new Date().setHours(0)));
  const [minDeliveryDate, setMinDeliveryDate] = useState();
  const [partner, setPartner] = useState("");
  const assignment = useAviationAssignment();
  const [tenderDateEnd, setTenderDateEnd] = useState("");
  const [tenderEndTime, setTenderEndTime] = useState("");
  const [partnersForTender, setPartnersForTender] = useState([]);
  const [points, setPoints] = useState([]);
  const [routeDistance, setRouteDistance] = useState();
  const [routeDuration, setRouteDuration] = useState("");
  const [currency, setCurrency] = useState("EUR");
  const [acceptedCurrency, setAcceptedCurrency] = useState(null);

  const [citiesRefreshCountryId, setCitiesRefreshCountryId] = useState(null);

  const [isActualCities, setIsActualCities] = useState(true);
  const [isCalculatePrice, setIsCalculatePrice] = useState(true);

  // files
  const [files, setFiles] = useState([]);
  const [fileInvoice, setInvoiceFile] = useState(null);

  //map
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);

  const updatePrice = (newPrice) => {
    setPrice(newPrice);
  };

  useEffect(() => {
    setIsActualCities(!(cityFrom?.isActual === false || cityTo?.isActual === false));
  }, [cityFrom, cityTo]);

  useEffect(() => {
    if (cityFrom?.id && cityTo?.id) {
      Order.getCalculateOrderPrice(cityFrom.id, cityTo.id)
        .then((response) => {
          setIsCalculatePrice(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [cityFrom, cityTo]);

  const getDefaultData = async () => {
    setLoadingGet(true);
    try {
      if (user && user.id) {
        await Order.getCountries(currentLanguage)
          .then((response) => {
            console.log("countries", response.data);
            setCountries(response.data);
          })
          .catch((error) => {
            console.log(error);
            toast.error(error);
          });
      } else {
        console.log("Пользователь не определен");
        setCountries([]);
      }

      // Остальные закомментированные запросы с такой же проверкой, если они понадобятся
    } catch (e) {
      toast.error("Ошибка при загрузке данных");
    } finally {
      setLoadingGet(location.pathname === `/orders/draft/${orderId}/edit`);
    }
  };

  useEffect(() => {
    getDefaultData();
  }, [user, currentLanguage]);

  useEffect(() => {
    Expeditor.getPartners()
      .then((response) => {
        if (response.status === 200) {
          const filteredPartners = response.data
            .filter((partner) => partner.state === "Confirmed" && partner.companyName)
            .map((partner) => ({
              ...partner,
              name: partner.companyName,
            }));

          setPartners(filteredPartners);
        } else {
          console.log("Список пуст");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (
      orderId &&
      location.pathname === `/orders/draft/${orderId}/edit` &&
      types.length &&
      temperatures.length &&
      loadingTypes.length &&
      categories.length &&
      countries.length
    ) {
      getOrderDetailDraft();
    }
  }, [orderId, loadingTypes]);

  useEffect(() => {
    if (citiesRefreshCountryId) {
      const responseEvent = (cities) => {
        const targets = getCitiesRefreshTargets(citiesRefreshCountryId, countryFrom, countryTo);
        if (targets.from) setCitiesFrom(cities);
        if (targets.to) setCitiesTo(cities);
        if (targets.from && orderDraft?.CityIdFrom && !cityFrom) {
          setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
        }
      };

      Order.getCities(currentLanguage, citiesRefreshCountryId)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        })
        .finally(() => {
          setCitiesRefreshCountryId(null);
        });
    }
  }, [citiesRefreshCountryId]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesFrom(cities);
      if (orderDraft?.CityIdFrom && !cityFrom) {
        setCityFrom(cities?.find((c) => c.id === orderDraft?.CityIdFrom));
      }
    };

    if (citiesTo.length && countryFrom?.id && countryTo?.id === countryFrom.id) {
      responseEvent(citiesTo);
    } else if (countryFrom?.id) {
      Order.getCities(currentLanguage, countryFrom.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryFrom]);

  useEffect(() => {
    const responseEvent = (cities) => {
      setCitiesTo(cities);
      if (orderDraft?.CityIdTo && !cityTo) {
        setCityTo(cities?.find((c) => c.id === orderDraft?.CityIdTo));
      }
    };
    if (citiesFrom.length && countryTo?.id && countryFrom?.id === countryTo.id) {
      responseEvent(citiesFrom);
    } else if (countryTo?.id) {
      Order.getCities(currentLanguage, countryTo.id)
        .then((res) => res.data)
        .then((data) => {
          const cities = data?.filter(city => city.name).sort((a, b) => a.name.localeCompare(b.name));
          console.log("cities", cities);
          responseEvent(cities);
        })
        .catch((error) => {
          requestErrorDisplay(error);
        });
    }
  }, [countryTo]);

  useEffect(() => {
    setIsLoadingMap(true);

    const isAddressRoute = addressIdFrom && addressIdTo && coordinatesFrom && coordinatesTo;
    const routeMethod = isAddressRoute ? "getRouteByAddressId" : "getRoute";
    const routeParams = isAddressRoute
      ? [addressIdFrom, addressIdTo]
      : [cityFrom?.id, cityTo?.id];

    if ((isAddressRoute && addressIdFrom && addressIdTo) || (!isAddressRoute && cityFrom?.id && cityTo?.id)) {
      MapsData[routeMethod](...routeParams)
        .then((response) => {
          try {
            if (response) setRouteDistance(response.data.distance);
            let parsedData = JSON.parse(response.data.jsonData);

            if (
              (isAddressRoute && response.data.fromCityId !== addressIdFrom) ||
              (!isAddressRoute && response.data.fromCityId !== cityFrom?.id)
            ) {
              parsedData = parsedData.reverse();
            }

            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
              console.log(`[${routeMethod}]`, null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });
    }
  }, [cityFrom, cityTo, addressIdFrom, addressIdTo, coordinatesFrom, coordinatesTo]);

  const getOrderDetailDraft = async () => {
    try {
      const res = await Order.getDraftOrder(orderId);
      const data = JSON.parse(res.data?.jsonData || "null");
      const discDraftKeys = {
        AddressFrom: {
          setEvent: setAddressFrom,
        },
        AddressTo: {
          setEvent: setAddressTo,
        },
        RecipientEmail: {
          setEvent: setRecipientEmail,
        },
        RecipientName: {
          setEvent: setRecipientName,
        },
        RecipientPhoneNumber: {
          setEvent: setRecipientPhone,
        },
        Details: {
          setEvent: setDetails,
        },
        Distance: {
          setEvent: setDistance,
        },
        IsInsurance: {
          setEvent: setInsurance,
        },
        DeclaredPrice: {
          setEvent: setDeclaredPrice,
        },
        CopyCount: {
          setEvent: setCopyCount,
        },
        Volume: {
          valueType: "string",
          setEvent: setVolume,
        },
        Weight: {
          valueType: "string",
          setEvent: setWeight,
        },
        VehicleType: {
          setEvent: setType,
          findKey: "value",
          items: types,
        },
        TemperatureId: {
          setEvent: setTemperature,
          findKey: "id",
          items: temperatures,
        },
        LoadingTypeId: {
          setEvent: setLoadingType,
          findKey: "id",
          items: loadingTypes,
        },
        Category: {
          setEvent: setCategory,
          findKey: "value",
          items: categories,
        },
        CountryIdFrom: {
          setEvent: setCountryFrom,
          findKey: "id",
          items: countries,
        },
        CountryIdTo: {
          setEvent: setCountryTo,
          findKey: "id",
          items: countries,
        },
      };
      setOrderDraft(data);

      if (data) {
        for (const draftKey in discDraftKeys) {
          const valueFromServer = data[draftKey];
          if (valueFromServer) {
            const item = discDraftKeys[draftKey];
            if (item.findKey) {
              item.setEvent(item.items.find((c) => c[item.findKey] === valueFromServer));
            } else if (item.valueType === "string") {
              item.setEvent(valueFromServer.toString());
            } else {
              item.setEvent(valueFromServer);
            }
          }
        }
      }
      if (data?.ShippingDate) {
        const dateFormat = moment(data?.ShippingDate).format("YYYY-MM-DD");
        setPickUpDate(new Date(dateFormat + "T00:00:00"));
        const startTime = data?.ShippingHourFrom
          ? data?.ShippingHourFrom > 9
            ? data?.ShippingHourFrom
            : "0" + data?.ShippingHourFrom
          : "09";
        const endTime = data?.ShippingHourTo
          ? data?.ShippingHourTo > 9
            ? data?.ShippingHourTo
            : "0" + data?.ShippingHourTo
          : "18";
        setPickUpStartTime(new Date(dateFormat + `T${startTime}:00:00`));
        setPickUpEndTime(new Date(dateFormat + `T${endTime}:00:00`));
      }
      if (data?.UnloadingDate) {
        const dateFormat = moment(data?.UnloadingDate).format("YYYY-MM-DD");
        setDeliveryDate(new Date(dateFormat + "T00:00:00"));
        const startTime = data?.UnloadingHourFrom
          ? data?.UnloadingHourFrom > 9
            ? data?.UnloadingHourFrom
            : "0" + data?.UnloadingHourFrom
          : "09";
        const endTime = data?.UnloadingHourTo
          ? data?.UnloadingHourTo > 9
            ? data?.UnloadingHourTo
            : "0" + data?.UnloadingHourTo
          : "18";
        setDeliveryStartTime(new Date(dateFormat + `T${startTime}:00:00`));
        setDeliveryEndTime(new Date(dateFormat + `T${endTime}:00:00`));
      }
    } catch (e) {
      requestErrorDisplay(e);
      throw e;
    } finally {
      setLoadingGet(false);
    }
  };

  const formData = () =>
    buildAviationOrderPayload(
      {
        userId: user.id,
        type: 0,
        isPublic: true,
        price,
        countryIdFrom: countryFrom?.id,
        cityIdFrom: cityFrom?.id,
        addressFrom: addressFrom,
        addressId: addressIdFrom,
        shippingDate: pickUpDate ? moment(pickUpDate).format("YYYY-MM-DD") : null,
        shippingHourFrom: pickUpStartTime ? Number(moment(pickUpStartTime).format("HH")) : null,
        shippingHourTo: pickUpEndTime ? Number(moment(pickUpEndTime).format("HH")) : null,
        countryIdTo: countryTo?.id,
        cityIdTo: cityTo?.id,
        addressTo: addressTo,
        unloadingDate: deliveryDate ? moment(deliveryDate).format("YYYY-MM-DD") : null,
        unloadingHourFrom: deliveryStartTime ? Number(moment(deliveryStartTime).format("HH")) : null,
        unloadingHourTo: deliveryEndTime ? Number(moment(deliveryEndTime).format("HH")) : null,
        details: details || t("ordersCreateDesktop.detailsSection.noDescription"),
        weight: weight ? String(weight).replace(",", ".") : null,
        volume: volume ? String(volume).replace(",", ".") : null,
        categoryName: categoryName,
        copyCount: copyCount,
        expeditorId: "",
        distance: 0,
        recipientName: recipientName,
        recipientEmail: recipientEmail,
        recipientPhoneNumber: recipientPhone,
        currency: acceptedCurrency,
        acceptedCurrency: acceptedCurrency,
      },
      {
        ...assignment,
        partner,
        partnersForTender,
        tenderDateEnd,
        tenderEndTime,
        price,
        currency,
        acceptedCurrency,
      },
    );

  const createOrder = () => {
    const data = formData();

    setLoading(true);
    setLoadingCreate(true);

    Aviation.createOrder(data)
      .then((res) => res.data)
      .then((response) => {
        toast.success(t('ordersCreate.toast.orderCreated'));

        if (files.length) {
          const uploadPromises = files.map(f => uploadFile(response[0]?.id, f, 6));

          Promise.all(uploadPromises)
            .finally(() => {
              setLoading(false);
              setLoadingCreate(false);
              onOrderCreated(response[0]?.id);
            });
        } else {
          setLoading(false);
          setLoadingCreate(false);
          onOrderCreated(response[0]?.id);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoadingCreate(false);
        requestErrorDisplay(error, "Произошла ошибка, попробуйте позже");
      })
      .finally(() => {
        setLoading(false);
      })

  };

  const uploadFile = (orderId, file, type = 6) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("orderId", orderId);
    formData.append("FileName", file.name);
    formData.append("name", file.name);
    formData.append("Name", file.name);

    return File.addOrderDoc(formData)
      .then(() => {
        toast.info(t('ordersCreate.toast.fileUploaded'));
      })
      .catch((error) => {
        console.log(error);
        requestErrorDisplay(error, 'ordersCreate.errors.uploadFileError');
        return Promise.reject(error);
      });
  };

  const onOrderCreated = (orderId) => {
    navigate(`/aviation/list`);
  };

  const queryInsurance = () => {
    if (insurance) {
      setInsurance(false);
      setDeclaredPrice(0);
      setInsurancePrice(null);
      setInvoiceFile({});
    } else {
      setInsurance(true);
    }
  };
  const calcInsurance = (val) => {
    setDeclaredPrice(val);
    if (+val) setInsurancePrice(Math.trunc((+val / 100) * 0.3));
    else setInsurancePrice(null);
  };

  if (isLoadingGet) {
    return <Loading inBlock />;
  }


  const getPropsData = () => ({
    recipientPhone,
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    airportFrom,
    airportTo,
    setAirportFrom,
    setAirportTo,
    airportsFrom,
    airportsTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    minDeliveryDate,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    types,
    setType,
    setTemperature,
    type,
    addressTo,
    setAddressTo,
    setRecipientPhone,
    setRecipientName,
    recipientName,
    recipientUpdate,
    setRecipientEmail,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    volume,
    setVolume,
    weight,
    setWeight,
    categories,
    category,
    setCategory,
    categoryName,
    setCategoryName,
    temperatures,
    temperature,
    loadingTypes,
    loadingType,
    setLoadingType,
    details,
    setDetails,
    insurance,
    queryInsurance,
    declaredPrice,
    calcInsurance,
    fileInvoice,
    setInvoiceFile,
    files,
    setFiles,
    distance,
    price,
    insurancePrice,
    createLoading,
    copyCount,
    setCopyCount,
    createOrder,
    updatePrice,
    setIsСallСities: setCitiesRefreshCountryId,
    isCalculatePrice,
    isLoadingMap,
    routeData,
    routeStartCity,
    partners,
    setPartner,
    partner,
    ...assignment,
    tenderDateEnd,
    tenderEndTime,
    setTenderDateEnd,
    setTenderEndTime,
    partnersForTender,
    setPartnersForTender,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    setPoints,
    senderName,
    setSenderName,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
    acceptedCurrency,
    setAcceptedCurrency,
    currency,
    setCurrency,
  });

  return (
    <>
      {isLoading && <Loading/>}
      <OrdersCreateAviationView
        {...getPropsData()}
        onPriceChange={setPrice}
        errors={errors}
        setErrors={setErrors}
      />
    </>
  );
};

export default OrdersAviationCreatePage;
